function NavigatorButtons({ children }) {
  return (
    <div className="select-none h-max w-full flex flex-col py-1">
      {children}
    </div>
  );
}

export default NavigatorButtons;
